"session".datatype({source: "WC"})
"userHasAdminRights".field()
"user".field()
"decimalSeparator".field()
"thousandSeparator".field()
"atumIsActive".field()
"databaseIsOptimized".field()
"seatsInUseCount".field({numeric: true})
"wcPricesIncludeTax".field() // NOTE: string yes/no
